import { useState } from 'react';

import Button from '@/shared/components/UI/Button';
import ShippingPolicyModal from '@/shared/components/UI/ShippingPolicyModal';
import TermsOfServiceModal from '@/shared/components/UI/TermsOfServiceModal';
import RefundPolicyModal from '@/shared/components/UI/RefundPolicyModal';
import PrivacyPolicyModal from '@/shared/components/UI/PrivacyPolicyModal';

const Footer = () => {
  const [isShippingModalOpen, setIsShippingModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  return (
    <footer className="w-full bg-[#4a4a4a] py-12">
      <div className="mx-auto flex max-w-5xl justify-between px-7">
        <div className="flex w-[25rem] flex-col gap-10">
          <div>
            <h3 className="mb-3 text-[14px] font-bold tracking-[.1rem] text-white">
              GUIDE
            </h3>
            <p className="mb-3 flex items-center gap-2 text-[12px] font-normal text-[#aaa]">
              <Button
                type="button"
                variant="ghost"
                onClick={() => setIsShippingModalOpen(true)}
                className="h-auto p-0 text-[12px] font-normal text-[#aaa] underline-offset-2"
              >
                Shipping Policy
              </Button>
              <span>|</span>
              <Button
                type="button"
                variant="ghost"
                onClick={() => setIsRefundModalOpen(true)}
                className="h-auto p-0 text-[12px] font-normal text-[#aaa] underline-offset-2"
              >
                Return and Refund Policy
              </Button>
            </p>
            <p className="mb-3 flex items-center gap-2 text-[12px] font-normal text-[#aaa]">
              <Button
                type="button"
                variant="ghost"
                onClick={() => setIsTermsModalOpen(true)}
                className="h-auto p-0 text-[12px] font-normal text-[#aaa] underline-offset-2"
              >
                Terms of Service
              </Button>
              <span>|</span>
              <Button
                type="button"
                variant="ghost"
                onClick={() => setIsPrivacyModalOpen(true)}
                className="h-auto p-0 text-[12px] font-normal text-[#aaa] underline-offset-2"
              >
                Privacy Policy
              </Button>
            </p>
          </div>
          <div>
            <h3 className="mb-3 text-[14px] font-bold tracking-[.1rem] text-white">
              K-MONSTAR
            </h3>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              주식회사 브이에이트코프 VEIGHTCORP. CO. LTD.
            </p>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              Business No. 653- 86-02204
            </p>
            <div className="mb-3 flex flex-col gap-1">
              <p className="text-[12px] font-normal text-[#aaa]">
                Address. 경기도 김포시 김포한강5로 321, 6층 618호
              </p>
              <p className="text-[12px] font-normal text-[#aaa]">
                (구래동, 김포한강 듀클래스)
              </p>
            </div>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              CEO : 김정율
            </p>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              Office Hours. 10:00AM-19:00PM (GMT+9)
            </p>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              Contact Us. help@kmonstar.com
            </p>
            <p className="mb-3 text-[12px] font-normal text-[#aaa]">
              Tel. 070-7543-8962
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <Button
            type="button"
            variant="ghost"
            onClick={() =>
              window.open(
                'https://hanteochart.com/family/search',
                '_blank',
                'noopener,noreferrer',
              )
            }
            className="mr-1 h-[100px] w-[200px] p-0"
          >
            <img
              src="/images/hanteoChart2025.png"
              alt="hanteo"
              className="ml-3 h-[100px] w-[200px]"
            />
          </Button>
          <img
            src="/images/circle-chart.png"
            alt="circle-chart"
            className="ml-3 h-[150px] w-[150px]"
          />
        </div>
      </div>
      <p className="mt-7 text-center text-[12px] font-normal text-[#999]">
        COPYRIGHT K-MONSTAR ALL RIGHTS RESERVED.
      </p>

      <ShippingPolicyModal
        isOpen={isShippingModalOpen}
        onClose={() => setIsShippingModalOpen(false)}
      />
      <RefundPolicyModal
        isOpen={isRefundModalOpen}
        onClose={() => setIsRefundModalOpen(false)}
      />
      <TermsOfServiceModal
        isOpen={isTermsModalOpen}
        onClose={() => setIsTermsModalOpen(false)}
      />
      <PrivacyPolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
      />
    </footer>
  );
};

export default Footer;
